import { Component } from 'preact'
import Icon from '../assets/index'

class AlertComponent extends Component {
  constructor (props) {
    super()
    this.state = {
      isVisible: true,
      isVisibleFor: props.isVisibleFor || false
    }
  }

  componentDidMount () {
    if (this.state.isVisible && this.state.isVisibleFor) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() =>
        this.setState({ isVisible: false }, () => {
          if (this.props.onTimeoutEnd) {
            this.props.onTimeoutEnd()
          }
        }), this.state.isVisibleFor)
    }
  }

  onClose () {
    this.setState({ isVisible: false })

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  render (props, state) {
    if (props.messageType === null) {
      return null
    }

    const type = {
      'error': 'danger',
      'success': 'success'
    }

    const defaultMessage = {
      'error': 'Changes could not be applied',
      'success': 'Changes applied successfully!'
    }

    const attributes = {
      role: 'alert',
      className: `alert-notification alert alert-${type[props.messageType]} box--alert box__pad`
    }

    if (props.sticky) attributes.className += ' sticky-top'

    return (
      <div
        {...!state.isVisible && { style: { display: 'none' } }}
        {...attributes} >
        {
          props.children.length ? props.children : (
            <div dangerouslySetInnerHTML={props.renderHTML ? { __html: props.message } : null}>
              { props.message ? props.message : defaultMessage[props.messageType] }
            </div>
          )
        }
        <Icon icon='close' customClass='alert-notification__close' onClick={() => this.onClose()} />
      </div>
    )
  }
}

export default AlertComponent
